import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { CompactDots } from 'wanderu-animations';
import { CarrierLogo } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import chiku from 'wanderu-assets/images/chiku.svg';
import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import styles from './LiveCheckLoader.scss';

const LiveCheckLoader = ({
    carrierCode,
    carrierName,
    onLoad,
    t,
}) => {
    useEffect(() => {
        if (onLoad) {
            onLoad();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            className={styles.container}
            role="alert"
        >
            {carrierCode && <>
                <div className={styles.logos}>
                    <span className={styles.logo}>
                        <img alt="" className={styles.chiku} src={chiku} />
                    </span>
                    <CompactDots classes={{ container: styles.dots }} />
                    <span className={styles.logo}>
                        <CarrierLogo
                            carrierCode={carrierCode}
                            carrierName={carrierName}
                            className={styles.image}
                        />
                    </span>
                </div>
                <hr className={styles.hr} />
            </>}
            <p className={styles.checkingText}>{t('livemodal-title')}</p>
        </div>
    );
};

LiveCheckLoader.propTypes = {
    carrierCode: PropTypes.string,
    carrierName: PropTypes.string,
    onLoad: PropTypes.func,
    t: PropTypes.func,
};

export { LiveCheckLoader };

export default localize(LiveCheckLoader, baseAppConfig.namespace);
